import { render, staticRenderFns } from "./mallApp.vue?vue&type=template&id=0e605d3f&"
import script from "./mallApp.vue?vue&type=script&lang=ts&"
export * from "./mallApp.vue?vue&type=script&lang=ts&"
import style0 from "./mallApp.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports